import { MonthlyPeriod } from "global";
import BoxWithShadow from "../../common/components/BoxWithShadow";
import { useGetIncentiveDashboardAsAdminQuery } from "../../../lib/apollo/graphql/generated";
import Loader from "../../common/components/Loader";
import CountCard from "../../common/components/CountCard";

interface IncentiveMetadataProps {
  period: MonthlyPeriod;
}

function Wrapper({ children }: { children: React.ReactNode }) {
  return (
    <BoxWithShadow className="w-1/6 flex-shrink-0">{children}</BoxWithShadow>
  );
}

export default function IncentiveMetadata({ period }: IncentiveMetadataProps) {
  const { year, month } = period;

  const { data, loading } = useGetIncentiveDashboardAsAdminQuery({
    variables: {
      year,
      month,
    },
  });

  if (loading) {
    return (
      <Wrapper>
        <Loader />
      </Wrapper>
    );
  }

  const metadata = data?.getIncentiveDashboardAsAdmin;

  return (
    <Wrapper>
      <div className="flex h-full flex-col gap-3 overflow-y-auto">
        <CountCard
          label="누적 지급액"
          unit="원"
          count={metadata?.accumulatedAmount}
          percentage={metadata?.previousMonthAccumulatedAmountDifference}
          percentageUnit="원"
          percentageLabel="(전월대비)"
        />
        <CountCard
          label="이번달 총 지급액"
          unit="원"
          count={metadata?.thisMonthTotalAmount}
          percentage={metadata?.previousMonthThisMonthTotalAmountRate}
          percentageLabel="(전월대비)"
        />
        <CountCard
          label="이번달 지급 대상자 수"
          unit="명"
          count={metadata?.thisMonthTotalReceivedUserCount}
          percentage={
            metadata?.previousMonthThisMonthTotalReceivedUserCountRate
          }
          percentageLabel="(전월대비)"
        />
        <CountCard
          label="포인트 사용자 수"
          unit="명"
          count={metadata?.pointUsedCount}
          percentage={metadata?.previousMonthPointUsedCountRate}
          percentageLabel="(전월대비)"
        />
        <CountCard
          label="평균 지급액"
          unit="원"
          count={metadata?.averageReceivedAmount}
          percentage={metadata?.previousMonthAverageReceivedAmountRate}
          percentageLabel="(전월대비)"
        />
      </div>
    </Wrapper>
  );
}
